// Module
var code = "<i class=\"fas fa-caret-up\" ng-if=!$ctrl.reverse></i> <i class=\"fas fa-caret-down\" ng-if=$ctrl.reverse></i> ";
// Exports
module.exports = code;